import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    getPlannedList,
    getPlannedCheckItemsByGroup,
    updatePlannedCIG,
    deletePlannedCIG,
    addPlannedCIG,
    deletePlannedCI,
    addPlannedCI,
    getPlannedCheckItemFiles,
    addPlannedCheckItemFiles,
    deletePlannedCheckItemFiles,
} from "../../store/actions/CheckItemGroupActions";
import moment from "moment";
import { getFormDataFromFiles, getSelectedFileNames } from "../../common";
import CheckItemGroup from "../../components/CheckItemGroup/CheckItemGroup";

export default function PlannedCheckItemGroup() {
    const dispatch = useDispatch();
    const [initialRows, setInitialRows] = useState([]);
    let [rows, setRows] = useState([]);
    let [items, setItems] = useState([]);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [startDate, setStartDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
    const [CIGName, setCIGName] = useState("");
    const [CIGNote, setCIGNote] = useState("");

    const { plannedItemGroupList, plannedItemListByGroupId, isTaskUpdatedCheckItemGroup, plannedCheckItemFiles } = useSelector(({ CheckItemGroup }) => CheckItemGroup);

    useEffect(() => {
        loadHandler();
    }, []);

    useEffect(() => {
        if (plannedItemGroupList?.resultObject) {
            //resultObject
            setPageLoaded(true);
            setRows(Object.values(plannedItemGroupList.resultObject.reverse()));
            setInitialRows(cloneObject(Object.values(plannedItemGroupList.resultObject)));
        }
    }, [plannedItemGroupList]);

    // for check items by group id
    useEffect(() => {
        if (plannedItemListByGroupId?.resultObject) {
            //resultObject
            setPageLoaded(true);
            setItems(Object.values(plannedItemListByGroupId.resultObject));
        }
    }, [plannedItemListByGroupId]);

    useEffect(() => {
        if (isTaskUpdatedCheckItemGroup) {
            loadHandler();
        }
    }, [isTaskUpdatedCheckItemGroup]);

    useEffect(() => {
        if (plannedCheckItemFiles) {
            setCheckItemFiles(plannedCheckItemFiles);
            setIsDocumentPopupOpen(true);
        }
    }, [plannedCheckItemFiles]);

    const cloneObject = (obj) => {
        return JSON.parse(JSON.stringify(obj));
    };

    const loadHandler = () => {
        getCheckItemGroupList();
    };

    const onStartDateChangeHandler = (date) => {
        setStartDate(date);
    };

    const onEndDateChangeHandler = (date) => {
        setEndDate(date);
    };

    const NameHandler = (name) => {
        setCIGName(name);
    };

    const NoteHandler = (note) => {
        setCIGNote(note);
    };

    const setRowsFunction = (newRows) => {
        setRows(newRows);
    };

    const getCheckItemGroupList = () => {
        dispatch(getPlannedList(true));
    };

    const idSender = (rowId) => {
        dispatch(getPlannedCheckItemsByGroup(rowId));
    };

    const updateAddHandlerCIG = (row) => {
        let data = {};
        if (row.id !== "") {
            setStartDate(row.validityStartDate);
            setEndDate(row.validityEndDate);
            data = {
                name: row.name !== CIGName ? CIGName : row.name,
                note: row.note !== CIGNote ? CIGNote : row.note,
                validityStartDate: row.validityStartDate !== startDate ? startDate : row.validityStartDate,
                validityEndDate: row.validityEndDate !== endDate ? endDate : row.validityEndDate,
            };
            dispatch(updatePlannedCIG({ id: row.id, data }));
            if (CIGName === "") {
                setCIGName(row.name);
            }
        } else {
            data = {
                name: CIGName,
                note: CIGNote,
                validityStartDate: startDate,
                validityEndDate: endDate,
            };
            dispatch(addPlannedCIG(data));
        }
    };

    const deleteCIHandler = (row) => {
        let data = {
            id: row.id,
            name: row.name,
            note: row.note,
        };
        dispatch(deletePlannedCI(data.id));
    };

    const deleteCIGHandler = (row) => {
        let data = {
            id: row.id,
            name: row.name,
            note: row.note,
        };
        dispatch(deletePlannedCIG(data.id));
    };

    const enableEditHandler = (row) => {
        setCIGName(row.name);
        setCIGNote(row.note);
        setStartDate(row.validityStartDate);
        setEndDate(row.validityEndDate);
    };

    const [checkItemGroupId, setCheckItemGroupId] = useState(null);

    const handleCheckItemAdd = (name, note) => {
        let data = {
            groupId: checkItemGroupId,
            name: name,
            note: note,
        };
        dispatch(addPlannedCI(data));
    };

    const openCheckItemPopup = (id) => {
        setCheckItemGroupId(id);
    };

    // File Management
    const [checkItemFiles, setCheckItemFiles] = useState([]);
    const [checkItemIdForFileUpload, setCheckItemIdForFileUpload] = useState(0);
    const [checkItemIdForFileDelete, setCheckItemIdForFileDelete] = useState(0);
    const [isFileUploaderPopupOpen, setIsFileUploaderPopupOpen] = useState(false);
    const [isDocumentPopupOpen, setIsDocumentPopupOpen] = useState(false);

    const HandleDocumentPopupOpen = (id) => {
        setCheckItemIdForFileDelete(id);
        dispatch(getPlannedCheckItemFiles(id));
    };

    const HandleFileUploaderPopupOpen = (id) => {
        setCheckItemIdForFileUpload(id);
        setIsFileUploaderPopupOpen(true);
    };

    const UploadFiles = (files) => {
        const formData = getFormDataFromFiles(files);
        const payload = {
            checkItemId: checkItemIdForFileUpload,
            data: formData,
        };
        console.log(payload);
        dispatch(addPlannedCheckItemFiles(payload));
        setIsFileUploaderPopupOpen(false);
    };

    const DeletePlannedCheckItemFile = (selectedFiles) => {
        const selectedFileNames = getSelectedFileNames(selectedFiles);
        const payload = {
            checkItemId: checkItemIdForFileDelete,
            fileNames: selectedFileNames,
        };
        console.log(payload);
        dispatch(deletePlannedCheckItemFiles(payload));
        setIsDocumentPopupOpen(false);
    };

    return (
        <CheckItemGroup
            rows={rows}
            setRowsFunction={setRowsFunction}
            initialRows={initialRows}
            pageLoaded={pageLoaded}
            items={items}
            handleCheckItemAdd={handleCheckItemAdd}
            openCheckItemPopup={openCheckItemPopup}
            idSender={idSender}
            enableEditHandler={enableEditHandler}
            deleteCIHandler={deleteCIHandler}
            deleteCIGHandler={deleteCIGHandler}
            updateAddHandlerCIG={updateAddHandlerCIG}
            onStartDateChangeHandler={onStartDateChangeHandler}
            onEndDateChangeHandler={onEndDateChangeHandler}
            NameHandler={NameHandler}
            NoteHandler={NoteHandler}
            HandleFileUploaderPopupOpen={HandleFileUploaderPopupOpen}
            HandleDocumentPopupOpen={HandleDocumentPopupOpen}
            isFileUploaderPopupOpen={isFileUploaderPopupOpen}
            isDocumentPopupOpen={isDocumentPopupOpen}
            setIsFileUploaderPopupOpen={setIsFileUploaderPopupOpen}
            setIsDocumentPopupOpen={setIsDocumentPopupOpen}
            UploadFiles={UploadFiles}
            DeleteCheckItemFile={DeletePlannedCheckItemFile}
            checkItemFiles={checkItemFiles}
        ></CheckItemGroup>
    );
}
